export default "__VITE_ASSET__Drsfi$el__"